export default {
  namespaced: true,
  state: { product: null },
  actions: {},
  getters: { product: state => state.product },
  mutations: {
    PRODUCT_UPDATED: (state, product) => {
      state.product = product
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/product/index.js